// Local
// export const API_HOST = "http://localhost:8000/"
// export const MAIN_HOST = 'http://localhost:8000/'
// export const BACKEND_API_HOST = "http://localhost:8000/backend/"
// export const IMG_HOST       = "http://localhost:8000/media/"
// export const DEFAULT_IMG    = MAIN_HOST + 'media/logo-default-user.png'

// export const API_TRACKING_HOST = "http://localhost:8080/"
// export const MAIN_TRACKING_HOST = 'http://localhost:8080/'
export const BACKEND_API_TRACKING_HOST = 'http://localhost:8080/backend/';

// postgre devel
// export const API_HOST = "https://postgre.presensi.co.id/"
// export const MAIN_HOST = "https://postgre.presensi.co.id/"
// export const BACKEND_API_HOST = "https://postgre.presensi.co.id/backend/"
// export const IMG_HOST = "https://postgre.presensi.co.id/media/"
// export const DEFAULT_IMG = MAIN_HOST + "media/logo-default-user.png"

//Development
// export const API_HOST = 'https://services-dev.presensi.co.id/';
// export const MAIN_HOST = 'https://services-dev.presensi.co.id/';
// export const BACKEND_API_HOST = 'https://services-dev.presensi.co.id/backend/';
// export const IMG_HOST = 'https://services-dev.presensi.co.id/media/';
// export const DEFAULT_IMG = MAIN_HOST + 'media/logo-default-user.png';
// export const VITE_API_MESSAGE = 'https://message-dev.belanjatech.com/api/v1/';
// export const VITE_COMPANY_ID = '6833df2839fd9718c77ef27a';
// export const VITE_IMG_MESSAGE_HOST = 'https://s3.belanjatech.com/media/';

// Production
export const API_HOST = 'https://services.presensi.comit.id/';
export const MAIN_HOST = 'https://services.presensi.co.id/';
export const BACKEND_API_HOST = 'https://services.presensi.co.id/backend/';
export const IMG_HOST = 'https://services.presensi.co.id/media/';
export const DEFAULT_IMG = MAIN_HOST + 'media/logo-default-user.png';
export const VITE_API_MESSAGE = 'https://messages.belanjatech.com/api/v1/';
export const VITE_COMPANY_ID = '688c38fee2e892bfe1ae9e3d';
export const VITE_IMG_MESSAGE_HOST = 'https://s3.belanjatech.com/media/';

export const APIKEY = 'AIzaSyAn3PgsveGi-bW-JH6YofGEoxk3UJwZr3E';
export const GOOGLECLOUDKEY = 'AIzaSyDLiF_vebUPQLa-4ayyovMQ0qSUrp5mNF4';
export const GOOGLECLIENTID = '319683777175-mjaj7t7a48i8c96v8uvcdgmg8556kbl9.apps.googleusercontent.com';
